import { createAction, props } from '@ngrx/store'
import { ChangeItem } from '../../model'
import { ComponentChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/component-with-changes.interface'

export enum ChangeRequestComponentActionTypes {
  MODIFY_COMPONENT = '[Change Request Component] Modify Component',
  MODIFY_COMPONENT_SUCCESS = '[Change Request] Modify Component Success',
  MODIFY_COMPONENT_FAIL = '[Change Request] Modify Component Fail',

  DELETE_COMPONENT = '[Change Request Component] Delete Component',
  DELETE_COMPONENT_SUCCESS = '[Change Request Component] Delete Component Success',
  DELETE_COMPONENT_FAIL = '[Change Request Component] Delete Component Fail',
  REVERT_DELETED_COMPONENT = '[Change Request Component] Revert Deleted Component',
}

const modifyComponent = createAction(
  ChangeRequestComponentActionTypes.MODIFY_COMPONENT,
  props<{ identity: number; parentId?: number; changes: ComponentChanges }>()
)
const modifyComponentSuccess = createAction(
  ChangeRequestComponentActionTypes.MODIFY_COMPONENT_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const modifyComponentFail = createAction(
  ChangeRequestComponentActionTypes.MODIFY_COMPONENT_FAIL,
  props<{ error: Error }>()
)

const deleteComponent = createAction(
  ChangeRequestComponentActionTypes.DELETE_COMPONENT,
  props<{ componentId: number; deliverableId: number }>()
)
const deleteComponentSuccess = createAction(
  ChangeRequestComponentActionTypes.DELETE_COMPONENT_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const deleteComponentFail = createAction(
  ChangeRequestComponentActionTypes.DELETE_COMPONENT_FAIL,
  props<{ error: Error }>()
)

const revertDeletedComponent = createAction(
  ChangeRequestComponentActionTypes.REVERT_DELETED_COMPONENT,
  props<{ componentId: number }>()
)

export const ChangeRequestComponentActions = {
  modifyComponent,
  modifyComponentSuccess,
  modifyComponentFail,
  deleteComponent,
  deleteComponentSuccess,
  deleteComponentFail,
  revertDeletedComponent,
}
